// Handle state refresh on navigation
import { MapSearch } from "./map_search";

const setupStateRefresh = () => {
  console.log('setup state refresh');
  const searchFilter = document.getElementById('search');
  const filters = document.querySelectorAll('.custom-switch input[type=checkbox]');
  const parkWithFilter = document.getElementById('dropdownParkWithFilter');

  if (!searchFilter || !parkWithFilter) {
    return;
  }

  const handleTurboRender = (event) => {
    MapSearch.refreshSearchState(searchFilter, filters, parkWithFilter);
    if (!document.documentElement.hasAttribute('data-turbo-preview')) {
      document.removeEventListener('turbo:render', handleTurboRender);
    }
  };

  document.addEventListener('turbo:render', handleTurboRender);
};

document.addEventListener('turbo:before-visit', setupStateRefresh);
